module.exports = __webpack_public_path__ + "static/media/dark-recent-source.7123e8ef.svg";